import { Helper } from './../../../services/helper.service';
import { AppInitHelper } from '../../../services/helpers/app-init.helper';
// import { SocketService } from '../../../services/socket.service';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OnInit } from '@angular/core';
import { PromptService } from '../../../services/prompt.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../../general/dialog/confirm/dialog.component';
import { DetailStore } from '../../../services/stores/detail.store';
import { UiStateStore } from '../../../services/stores/ui-state.store';
import { environment } from '../../../../environments/environment';
// import { OktaAuthService } from '@okta/okta-angular';
import { OrganizationStore } from '../../../services/stores/organization.store';
import { BaseComponent } from '../../base/base.component';
import { PermissionService } from '../../../services/permission.service';
import { DashboardHelper } from '../../../services/dashboard.service';
import { UserService } from '../../../services/user.service';
import { UserStore } from '../../../services/stores/user.store';
// import { MaterialModule } from '../../../modules/catch-core/third-party/material/material.module';
// import { FormsModule } from '@angular/forms';
// import { HttpClient } from '@angular/common/http';
// import { AlertService } from '../../../services/alert.service';
// import { NotificationsService, SimpleNotificationsModule } from 'angular2-notifications';
// import { NgxPermissionsService } from 'ngx-permissions';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: false,
})
export class LoginComponent extends BaseComponent implements OnInit {
  username: string = '';
  password: string = '';
  showInvalidCredentialMessage = false;
  currentTermsVersion = 0;
  version = '';
  public isThirdPartyLoginAllow = true;
  loginError = { message: '' };
  // isAuthenticated: boolean = false;
  constructor(
    // private permissionsService: NgxPermissionsService,
    private promptsService: PromptService,
    private dialog: MatDialog,
    private uiStateStore: UiStateStore,
    private detailStore: DetailStore,
    private userStore: UserStore,
    private userService: UserService,
    private router: Router,
    private permissionService: PermissionService,
    // public oktaAuth: OktaAuthService,
    private dashboardHelper: DashboardHelper,
    private orgStore: OrganizationStore,
    // private socketService: SocketService,
    private appInitHelper: AppInitHelper,
    private helperService: Helper,
  ) {
    super();
    this.version = environment.version;
    // this.oktaAuth.$authenticationState.subscribe((isAuthenticated: boolean) => (this.isAuthenticated = isAuthenticated));
  }

  get prompts() {
    return this.promptsService.prompts;
  }

  async ngOnInit() {
    this.dashboardHelper.setExpandRightPanel(false);
    this.dashboardHelper.setShowRightPanel(false);
    this.dashboardHelper.setShowLeftSidePanel(false);
    this.dashboardHelper.setShowGraphPanel(false);
    this.dashboardHelper.setToggleLeftPanelCollapse(false);
    if (this.userService.isUserLoggedIn) {
      this.router.navigate(['/', 'dashboard', { outlets: { mainPanel: ['projectsview'] } }]);
    }
    this.showInvalidCredentialMessage = false;
    this.loginError = { message: '' };
    // this.isAuthenticated = await this.oktaAuth.isAuthenticated();
    this.uiStateStore.loadInitialData();
    // if (this.isAuthenticated) {
    //   this.oktaAuth.getAccessToken().then((x) => {
    //     if (x) {
    //       this.Authenticate(x);
    //     }
    //   });
    // }

    this.subscribers.organisation = this.orgStore.$firstOrganization.subscribe((o) => {
      if (o) {
        // this.socketService.initSocket();
        this.redirectToDashBoard();
      }
    });
  }

  // login() {
  //   this.oktaAuth.loginRedirect('/');
  // }

  // logout() {
  //   this.oktaAuth.logout('/');
  // }

  checkNeedToShowTerms() {
    if (this.userService.user && this.currentTermsVersion > this.userService.user?.acceptedTerms) {
      return true;
    }
    return false;
  }

  resetPassword() {
    this.router.navigate(['/password-reset']);
  }

  signup() {
    this.router.navigate(['/signup']);
  }

  redirectToDashBoard() {
    this.uiStateStore.endBackendAction('Loaded initial data successfully...!');
    this.router.navigate([
      '/',
      'dashboard',
      {
        outlets: {
          mainPanel: ['projectsview'],
        },
      },
    ]);
  }

  showTerms() {
    const needToShowTerms = this.checkNeedToShowTerms();

    if (!needToShowTerms) {
      this.uiStateStore.startBackendAction('Loading data...');
      if (!this.permissionService.isSysAdmin) {
        this.orgStore.clearOrgData();
        // this.orgStore.loadOrganization(this.userService.user?.organizationId);
      }
      this.appInitHelper.loadInitialData();
    } else {
      const dialogRef = this.dialog.open(DialogComponent, {
        width: '500px',
        maxWidth: '90vw',
        data: {
          title: 'Terms and Conditions',

          content:
            '<div class="textAlignCenter"> Please carefully read all the terms and conditions located at the address below: <br/> <a target="_blank" href="https://catchsoftware.com/products/enterprise-tester-original/eula/">https://catchsoftware.com/products/enterprise-tester-original/eula/</a> <br/><br/> If you AGREE to be bound by all the terms and conditions of this agreement, indicate your acceptance by clicking on the ACCEPT button below. <br/><br/> If you DO NOT AGREE to be bound by all the terms and conditions of this agreement, indicate that you do not accept by clicking on the DECLINE button below. <br/><br/> </div> ',
          cancelButton: 'DECLINE',
          confirmButton: 'ACCEPT',
          action: 'confirm',
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'yes') {
          this.uiStateStore.startBackendAction('Updating T&C acceptance...');
          this.userService.updateAcceptedTerms(this.currentTermsVersion).subscribe((res: any) => {
            if (res) {
              this.uiStateStore.startBackendAction('Loading data...');
              if (!this.permissionService.isSysAdmin) {
                this.orgStore.clearOrgData();
              }
              this.appInitHelper.loadInitialData();
            } else {
              this.uiStateStore.endBackendAction('Fail to update accepted T&C');
            }
          });
        } else {
          this.userService.logout();
        }
      });
    }
  }

  Authenticate(oktaToken: string) {
    const loginPromise = this.userStore.Login(this.username, this.password).toPromise();
    // if (oktaToken) {
    //   loginPromise = this.userService.oktaLogin(oktaToken).toPromise();
    // } else {

    // }

    this.uiStateStore.startBackendAction('Logging in...');
    loginPromise.then(
      (data: boolean | undefined) => {
        if (data) {
          this.uiStateStore.endBackendAction('Logged in successfully!');
        }
        if (data === true) {
          const perm = ['admin', 'member'];
          // this.permissionsService.loadPermissions(perm);
          // Get current T&C version number Then show Terms
          if (this.currentTermsVersion) {
            this.showTerms();
          } else {
            this.detailStore.$firstDetail.subscribe((d) => {
              if (d && this.currentTermsVersion === 0) {
                setTimeout(() => {
                  this.currentTermsVersion = Number(d.termsVersion);
                  this.showTerms();
                });
              }
            });
          }
        } else {
          this.showInvalidCredentialMessage = true;
          this.userService.logout();
        }
      },
      (error: any) => {
        if (error) {
          this.uiStateStore.endBackendAction('Failed to login');
          this.helperService.handleError(error);
          if (error.isPermissionLoadFailure) {
            this.loginError = {
              message: 'Signed in, but we could not load your permissions. Please try again.',
            };
          } else if (error.status === 404) {
            this.loginError = {
              message: 'User does not exist in CatchHub, please contact your administrator',
            };
          } else {
            this.showInvalidCredentialMessage = true;
          }
          this.userService.logout();
        }
      },
    );
  }
}
